var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.50547C4.47705 4.50547 0 8.98252 0 14.5055V18.3516C0 18.7332 0.279877 19.0571 0.657231 19.1127C1.03483 19.1681 1.39594 18.9385 1.50597 18.5732C1.50597 18.5732 1.63914 18.1296 1.84197 17.4556C2.9152 13.8857 6.19865 11.4386 9.9264 11.4305L10 11.4303V12.3083C10 13.1804 10.4918 13.978 11.2709 14.3698C12.0502 14.7617 12.9836 14.6807 13.6839 14.1606L19.0686 10.1604C19.6546 9.72492 20 9.03815 20 8.30806C20 7.57796 19.6546 6.89095 19.0686 6.4555L13.6839 2.45526C12.9836 1.93513 12.0502 1.85415 11.2709 2.24603C10.4918 2.6379 10 3.43544 10 4.30781V4.50547ZM1.53871 14.4749C1.5552 9.81575 5.33711 6.04393 10 6.04393H10.7692C11.1941 6.04393 11.5385 5.69956 11.5385 5.2747V4.30781C11.5385 4.01686 11.7024 3.75101 11.9621 3.62055C12.2218 3.48984 12.5329 3.51692 12.7663 3.69021C12.7665 3.69021 18.1511 7.69046 18.1511 7.69046C18.3463 7.83569 18.4615 8.06461 18.4615 8.30806C18.4615 8.55126 18.3463 8.78043 18.1511 8.92541L12.7665 12.9257C12.5329 13.0989 12.2218 13.126 11.9621 12.9956C11.7024 12.8649 11.5385 12.599 11.5385 12.3083V10.6593C11.5385 10.6593 11.7765 9.88787 10.7579 9.89009C10.7003 9.89033 10.3894 9.89083 9.9232 9.89206C6.47114 9.89944 3.34178 11.6764 1.53871 14.4749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIc);
export default __webpack_public_path__ + "static/media/export-ic.1210249cd62bdd3810b2f114b7d2c370.svg";
export { ForwardRef as ReactComponent };